var _circle, _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgWarning = function SvgWarning(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    fill: "none",
    viewBox: "0 0 29 29",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.15,
    cy: 14.976,
    r: 14,
    fill: "#fcf4dd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffae00",
    d: "M21.708 19.785 15.146 8.382c-.492-.847-1.778-.875-2.27 0L6.314 19.785c-.492.847.137 1.941 1.148 1.941H20.56a1.301 1.301 0 0 0 1.148-1.941Zm-7.683-2.38c.683 0 1.258.575 1.258 1.259 0 .71-.575 1.257-1.258 1.257a1.237 1.237 0 0 1-1.258-1.257c0-.684.547-1.258 1.258-1.258Zm-1.203-4.51c-.028-.192.136-.356.328-.356h1.722c.192 0 .356.164.329.355l-.192 3.719c-.027.191-.164.3-.328.3h-1.34c-.164 0-.3-.109-.328-.3l-.191-3.719Z"
  })));
};
export default SvgWarning;